import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, DeviceModel, EntityModel, DeviceHierarchyModel, DevicesEditModel, ObjectReferenceModel, SchemaModel, ResponseListModel, ResponseDeleteModel, DeviceActionsModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { IImportService } from './api.app.service'

export interface IDevicesService extends IImportService {
    getDevices(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    createDevice(req): ng.IPromise<DeviceModel>
    getDevice(id, state?: any): ng.IPromise<DeviceModel>
    getDeviceToEdit(id, state?: any): ng.IPromise<EntityModel>
    getParentDevices(id, state?: any): ng.IPromise<ResponseListModel<DeviceHierarchyModel>>
    getChildDevices(id, state?: any): ng.IPromise<ResponseListModel<DeviceHierarchyModel>>
    saveChildDevices(editModel: DevicesEditModel): ng.IPromise<ResponseListModel<DeviceHierarchyModel>>
    deleteDevice(id): ng.IPromise<ResponseDeleteModel>
    changeCurrentMeter(model: ObjectReferenceModel): ng.IPromise<DeviceModel>
    getSchema(id, state?: any): ng.IPromise<SchemaModel>
    getSchemas(id, state?: any): ng.IPromise<ResponseListModel<SchemaModel>>
    getDeviceConfigurationInconsistency(id, state?: any): ng.IPromise<EntityModel>
    sendDeviceConfiguration(id, state?: any): ng.IPromise<ResponseListModel<any[]>>
}

export class DevicesService implements IDevicesService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getDevices(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.devices.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getDevice(id, state: any = {}) {
        var get = this.apiResource.devices.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getDeviceToEdit(id, state: any = {}) {
        var getDeviceToEdit: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.devices['getDeviceToEdit']
        state.request = getDeviceToEdit({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getParentDevices(id, state: any = {}) {
        var getParentDevices: ng.resource.IResourceMethod<ng.resource.IResource<DeviceHierarchyModel[]>> = this.apiResource.devices['getParentDevices']
        state.request = getParentDevices({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getChildDevices(id, state: any = {}) {
        var getChildDevices: ng.resource.IResourceMethod<ng.resource.IResource<DeviceHierarchyModel[]>> = this.apiResource.devices['getChildDevices']
        state.request = getChildDevices({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    saveChildDevices(editModel: DevicesEditModel) {
        return this.apiResource.devices['saveChildDevices'](editModel).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    createDevice(req): ng.IPromise<DeviceModel> {
        return this.apiResource.devices.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteDevice(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.devices.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    changeCurrentMeter(model: ObjectReferenceModel) {
        return this.apiResource.devices['changeCurrentMeter'](model).$promise.then(result => {
            result = CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getSchema(id, state: any = {}) {
        var get = this.apiResource.locations['getSchema']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getSchemas(id, state: any = {}) {
        var get = this.apiResource.devices['getSchemas']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getDeviceConfigurationInconsistency(id, state: any = {}) {
        var get = this.apiResource.devices['getDeviceConfigurationInconsistency']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
    //import

    IsImportCompleted(model: GridModel) {
        return this.apiResource.devices['importIsCompleted'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getImportSummary(model: GridModel) {
        return this.apiResource.devices['importResume'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    initImport(model: GridModel) {
        return this.apiResource.devices['importInit'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getImportData(guid: string) {
        return this.apiResource.devices['importGetData']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    validateImport(guid: string) {
        return this.apiResource.devices['importValidate']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    startImport(guid: string) {
        return this.apiResource.devices['importStart']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    stopImport(guid: string) {
        return this.apiResource.devices['importStop']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importProgress(guid: string) {
        return this.apiResource.devices['importProgress']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importSummary(guid: string) {
        return this.apiResource.devices['importSummary']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    sendDeviceConfiguration(model: DeviceActionsModel, state: any = {}) {
        return this.apiResource.devices['sendDeviceConfiguration']( model ).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
}
